// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: Arial, sans-serif;
}
.shift-left {
    margin-left: -55px;
  }
.title h3{
    background-color: #6699cc;
    color: #ffffff;
    padding: 10px;
    text-align: left;
  }

.center-content {
    margin: auto !important;
    text-align: center;
}

.dropdown-container {
    display: flex;
    gap: 20px;
    align-items: center;
    margin-top: 20px;
}

.dropdown-container label {
    margin-right: 10px;
}

#doa-category, #doa-types, #orderby {
    width: 300px;
    height: 32px;
}

#orderby {
    width: 150px;
}

.button-container {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 20px;
}

.table-container {
    overflow-x: auto;
}

table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
}

th, td {
    border: 1px solid white;
    text-align: center;
    padding: 8px;
}

th {
    background-color: #0b2d71;
    font-weight: bold;
}

td a {
    color: blue;
    text-decoration: none; 
}

td a:hover {
    text-decoration: underline; 
}

.mat-elevation-z8 {
    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.mat-paginator {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}
.inline-container {
    display: flex;
    align-items: center;
    gap: 10px; 
}
.button-container {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 20px;
}
  .hidden-paginator {
    display: none;
  }

  .move-fullright {
    margin-left: 970px;
}
.large-checkbox {
    width: 20px;
    height: 20px;
}
/* .div-aln{
    margin-top: 20px;
} */
.details-box {
    align-items: center;
  }

  #department, #division, #doaCategory, #doaTypes {
    width: 490px;
    height: 30px; /* Increased height */   
}
.error-message {
    color: red;
    font-weight: bold;
    margin-top: 10px;
  }
  .bordered-container {
    border: 1px solid #d3d3d3; 
    padding: 20px;
    max-width: 100%;
    margin: 3% 0%;
    border-radius: 1px;
    padding-bottom: 5px;
  }
`, "",{"version":3,"sources":["webpack://./src/app/modules/delegationofauthority/searchdoadatabasereport/searchdoadatabasereport.component.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;AAClC;AACA;IACI,kBAAkB;EACpB;AACF;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,gBAAgB;EAClB;;AAEF;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2HAA2H;AAC/H;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;;GAEG;AACH;IACI,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY,EAAE,qBAAqB;AACvC;AACA;IACI,UAAU;IACV,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,yBAAyB;IACzB,aAAa;IACb,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,mBAAmB;EACrB","sourcesContent":["body {\n    font-family: Arial, sans-serif;\n}\n.shift-left {\n    margin-left: -55px;\n  }\n.title h3{\n    background-color: #6699cc;\n    color: #ffffff;\n    padding: 10px;\n    text-align: left;\n  }\n\n.center-content {\n    margin: auto !important;\n    text-align: center;\n}\n\n.dropdown-container {\n    display: flex;\n    gap: 20px;\n    align-items: center;\n    margin-top: 20px;\n}\n\n.dropdown-container label {\n    margin-right: 10px;\n}\n\n#doa-category, #doa-types, #orderby {\n    width: 300px;\n    height: 32px;\n}\n\n#orderby {\n    width: 150px;\n}\n\n.button-container {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    margin-top: 20px;\n}\n\n.table-container {\n    overflow-x: auto;\n}\n\ntable {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 20px;\n}\n\nth, td {\n    border: 1px solid white;\n    text-align: center;\n    padding: 8px;\n}\n\nth {\n    background-color: #0b2d71;\n    font-weight: bold;\n}\n\ntd a {\n    color: blue;\n    text-decoration: none; \n}\n\ntd a:hover {\n    text-decoration: underline; \n}\n\n.mat-elevation-z8 {\n    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12);\n}\n\n.mat-paginator {\n    margin-top: 20px;\n    display: flex;\n    justify-content: center;\n}\n.inline-container {\n    display: flex;\n    align-items: center;\n    gap: 10px; \n}\n.button-container {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    margin-top: 20px;\n}\n  .hidden-paginator {\n    display: none;\n  }\n\n  .move-fullright {\n    margin-left: 970px;\n}\n.large-checkbox {\n    width: 20px;\n    height: 20px;\n}\n/* .div-aln{\n    margin-top: 20px;\n} */\n.details-box {\n    align-items: center;\n  }\n\n  #department, #division, #doaCategory, #doaTypes {\n    width: 490px;\n    height: 30px; /* Increased height */   \n}\n.error-message {\n    color: red;\n    font-weight: bold;\n    margin-top: 10px;\n  }\n  .bordered-container {\n    border: 1px solid #d3d3d3; \n    padding: 20px;\n    max-width: 100%;\n    margin: 3% 0%;\n    border-radius: 1px;\n    padding-bottom: 5px;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
